module.exports = __webpack_public_path__ + "static/media/idea.84a7cf92.svg";